import { queries } from "../../shared/queries";
import { defaultCreatorGrants, type GrantEntry } from "../../shared/rbac/roles";
import { skillGrantsForSpace } from "../lib/skillGrantsForSpace";
import { useCurrentUserId } from "./useCurrentUserId";
import { useQuery } from "@rocicorp/zero/react";

export function useDefaultSkillGrants(spaceId?: string): GrantEntry[] {
  const userId = useCurrentUserId();
  const [spaceGrants] = useQuery(
    spaceId ? queries.roleGrantsByScope({ scopeId: spaceId }) : undefined
  );

  if (spaceId) {
    return skillGrantsForSpace(spaceGrants ?? [], userId);
  }
  return defaultCreatorGrants("skill", { userId });
}
